import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-printmycard',
  standalone: false,
  templateUrl: './printmycard.component.html',
  styleUrls: ['./printmycard.component.scss'],
  providers: [ApiService],
})
export class PrintmycardComponent implements OnInit {
  public source = '';
  public groupno = '';
  public bin = '';
  public pcn = '';
  public memberid = '';
  public groupno_valid = '';
  public medicineName = '';
  public cardLoaded = false;

  constructor(
    public ApiService: ApiService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.loadFromUrlAndPrint();
  }

  private loadFromUrlAndPrint(): void {
    const params = new URLSearchParams(window.location.search);
    this.source   = params.get('source')   || '';
    this.groupno  = params.get('groupno')  || '';
    this.medicineName = params.get('med')  || '';

    // When BIN + PCN are in the URL (passed by the pharmacy page), use them
    // directly — no API call needed, and it works reliably on mobile too.
    const urlBin      = params.get('bin')      || '';
    const urlPcn      = params.get('pcn')      || '';
    const urlMemberid = params.get('memberid') || '';

    if (urlBin && urlPcn && this.groupno) {
      this.bin          = urlBin;
      this.pcn          = urlPcn;
      this.memberid     = urlMemberid;
      this.groupno_valid = this.groupno;
      this.cardLoaded   = true;
      this.cdr.detectChanges();
      setTimeout(() => requestAnimationFrame(() => requestAnimationFrame(() => this.printPage())), 400);
      return;
    }

    if (!this.groupno) {
      console.warn('Print card: missing groupno query parameter');
      return;
    }

    // Fallback: fetch values from the API (used by My Cards page and others).
    this.printcard(this.groupno);
  }

  printcard(grpno: string): void {
    this.ApiService.printcard(grpno).subscribe({
      next: (data) => {
        if (!data?.[0]?.status) {
          console.warn('Print card: API returned status false');
          return;
        }

        const card = this.getCardFields(data[0]);
        if (!card) {
          console.warn('Print card: no card fields in API response');
          return;
        }

        this.bin = card.bin;
        this.pcn = card.pcn;
        this.groupno_valid = data[0].gn;
        this.memberid =
          this.groupno === 'GST1016' ? '48786' : card.member_Id;
        this.cardLoaded = true;

        // Force Angular to flush values to the DOM before the print dialog fires.
        // Critical on mobile — without this, interpolated values may still be empty.
        this.cdr.detectChanges();

        // Two rAFs guarantee the browser has painted the updated DOM before the
        // print dialog freezes rendering (iOS 13+ supports window.print() too).
        setTimeout(() => requestAnimationFrame(() => requestAnimationFrame(() => this.printPage())), 400);
      },
      error: (err) => {
        console.warn('Print card: API request failed', err);
      },
    });
  }

  private getCardFields(
    response: any,
  ): { bin: string; pcn: string; member_Id: string } | null {
    if (this.source === 'mobile' && response.mobile?.[0]) {
      return response.mobile[0];
    }
    if (this.source === 'web' && response.web?.[0]) {
      return response.web[0];
    }
    if (this.source === 'ecenter' && response.ecenter?.[0]) {
      return response.ecenter[0];
    }
    if (this.source === 'api' && response.api?.[0]) {
      return response.api[0];
    }
    if (response.def?.[0]) {
      return response.def[0];
    }
    return null;
  }

  printPage(): void {
    window.print();
  }
}
